import classNames from "classnames";
import { FC, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { msalApp } from "../context/authContext";
import useIdentity from "../hooks/useIdentity";
import useOnClickOutside from "../hooks/useOnClickOutside";
import useProfilePicture from "../hooks/useProfilePicture";
import useToggle from "../hooks/useToggle";
import { useI18n } from "../hooks/useTranslations";
import styles from "./AccountButton.module.css";
import SvgLogout from "./icons/Logout";
import SvgPerson from "./icons/Person";
import Icon from "./ui/Icon";

const AccountButton: FC = () => {
  const i18n = useI18n();
  const { close, isOpen, open } = useToggle();
  const identity = useIdentity();
  const navigate = useNavigate();
  const { picture } = useProfilePicture();

  const menuRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(menuRef, () => isOpen && close());

  const initials = `${identity?.lastName[0] ?? ""}${identity?.firstName[0] ?? ""}`;
  const fullName = `${identity?.lastName ?? ""} ${identity?.firstName ?? ""}`.trim();

  const handleLogout = async () => {
    await msalApp.logoutRedirect({ postLogoutRedirectUri: window.location.href });
    await msalApp.loginRedirect();
  };

  return (
    <>
      <div className={classNames(styles.avatar, isOpen && styles.open)} onClick={isOpen ? close : open}>
        {picture ? <img src={picture} className={styles["user-picture"]} /> : <Icon glyph={SvgPerson} />}
      </div>
      <div className={classNames(styles.account, isOpen && styles.visible)} ref={menuRef}>
        <div className={styles["user-info"]}>
          <div className={classNames(styles.avatar, styles.large)}>
            {picture ? <img src={picture} className={styles["user-picture"]} /> : initials}
          </div>
          <div>
            <div className={styles.name}>{fullName}</div>
            <Link to={`mailto:${identity?.email}`}>{identity?.email}</Link>
          </div>
        </div>
        <button className={styles.listElement} onClick={() => navigate("/me")}>
          <Icon glyph={SvgPerson} className={styles.icon} />
          {i18n.t.common.myProfile}
        </button>
        <button className={styles.logout} onClick={handleLogout}>
          <Icon glyph={SvgLogout} className={styles.icon} />
          {i18n.t.common.logout}
        </button>
      </div>
    </>
  );
};

export default AccountButton;
